import MobileDrawer from '@/components/common/mobileDrawer';
import { DarkButton } from '@acko-tech/building-blocks.ui.button';
import React from 'react';
import UnableProcess from '@/assets/Icons/unable-process.svg';
import CarDetailCard from '../carDetailsCard';
import { IVehicleDetails } from '@/types';
import { ModalTitle, SecondaryActionText, IconContainer } from './styles';
import {
    modalTitleLine1,
    modalTitleLine2,
    primaryActionText,
    secondaryActionText,
} from './message';
interface EvCarDependencyProps {
    show: boolean;
    clickCarHandler: () => void;
    close: () => void;
    clickHomeHandler: () => void;
    carData?: IVehicleDetails | null;
}

const evBlockModal = ({
    show,
    close,
    clickCarHandler,
    clickHomeHandler,
    carData,
}: EvCarDependencyProps) => {
    return (
        <MobileDrawer onClose={close} show={show}>
            <React.Fragment>
                <IconContainer>
                    <UnableProcess />
                </IconContainer>
                <ModalTitle>
                    {modalTitleLine1}
                    <br />
                    {modalTitleLine2}
                </ModalTitle>

                {carData && <CarDetailCard carData={carData} />}

                <DarkButton onClick={clickHomeHandler}>
                    {primaryActionText}
                </DarkButton>
                <SecondaryActionText onClick={clickCarHandler}>
                    {secondaryActionText}
                </SecondaryActionText>
            </React.Fragment>
        </MobileDrawer>
    );
};

export default evBlockModal;
